import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const isAuthorized = !!accessToken || token;

  if (!isAuthorized) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
